import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { protectedResources } from "src/app/b2c-config";

@Injectable({ providedIn: 'root' })
export class DashboardService {
    constructor(private http: HttpClient) { }
    
    public getSoftwareDashboardData(): Observable<any> {   
            return this.http.get(`${protectedResources.etlApi.endpoint}api/ReleaseManagement/GetSoftwareUpdateDashboardDetails`);  
    }
    public getPatchDeploymentDetails(): Observable<any> {    
        return this.http.get(`${protectedResources.etlApi.endpoint}api/ReleaseManagement/GetDeployementDetails`);  
}
}
